import { ChangeDetectionStrategy, Component } from '@angular/core';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from '@medsurf/flat-facades';

@Component({
    selector: 'medsurf-copyrights',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './copyrights.component.html',
    styleUrls: ['./copyrights.component.scss'],
    standalone: false
})
export class CopyrightsComponent {
  readonly FlatModels = FlatModels;

  constructor(public constantAuthorFacade: FlatFacades.ConstantAuthorFacade,
              public navigationControlFacade: FlatFacades.NavigationControlFacade) {
  }

  rowTrackBy(index: number,
             item: FlatModels.CopyrightEntityModels.Copyright) {
    return item.id || index;
  }

  onRowSelect($event: any) {
    this.navigationControlFacade.requestNavigate(['copyright', $event.data]);
  }

  addNewCopyright() {
    this.navigationControlFacade.requestNavigate(['copyright']);
  }
}
